import { ContentNodes } from "@/components/content/ContentNodes";
import { getChapter } from "@/content/chapters";
import type { RouteId } from "@/routing/routes";
import "./ChapterView.css";

/**
 * Renders a complete canonical view from its content module.
 * Per-route classes give each chapter its own composition and emphasis
 * while sharing the botanical-glass shell and type system.
 */
export function ChapterView({ route }: { route: RouteId }) {
  const chapter = getChapter(route);
  return (
    <article className={`chapter-view chapter-${route}`} data-chapter={route}>
      <ContentNodes nodes={chapter.nodes} route={route} />
    </article>
  );
}
